import { render, staticRenderFns } from "./SubscriptionExpiredPopup.vue?vue&type=template&id=2fec2c37&scoped=true&"
import script from "./SubscriptionExpiredPopup.vue?vue&type=script&lang=js&"
export * from "./SubscriptionExpiredPopup.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionExpiredPopup.vue?vue&type=style&index=0&id=2fec2c37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fec2c37",
  null
  
)

export default component.exports